import Confetti from 'react-confetti'
import { useTranslation } from 'summon-ui/intl'
import { Button, Modal, Title, Text, Stack } from 'summon-ui/mantine'

type LevelUpModalProps = {
  open: boolean
  close: () => void
  currentLevel: number
}

const LevelUpModal = ({ currentLevel, open, close }: LevelUpModalProps) => {
  const t = useTranslation()

  return (
    <>
      {open && <Confetti className='h-screen w-screen z-[9000]' />}
      <Modal opened={open} onClose={close} maw={350} radius='md'>
        <Stack justify='center'>
          <p className='text-brand font-gibson whitespace-normal px-4 py-16 text-center text-7xl [word-spacing:4px]'>
            {t('Level')} {currentLevel}
          </p>
          <div>
            <Title order={3} ta='center'>
              {t('Movin’ on up!')}
            </Title>
            <Text ta='center' size='xs'>
              {t('You completed all the required quests and actions and earned all the required XP.')}
            </Text>
          </div>
          <Button fullWidth onClick={close} mt='6'>
            {t('Close')}
          </Button>
        </Stack>
      </Modal>
    </>
  )
}

export default LevelUpModal
